import { createUseMutationHook } from 'hooks/createUseMutationHook';

export const useServiceDocumentChange = createUseMutationHook(
    'service_document_change',
    () => [
        ['person_trip_detail'],
    ],
);
